import { computed, Injectable } from '@angular/core';
import { EmploymentContractEnum } from '@libs/types/src/user/enum/employment-contract.enum';
import { Operations, ServiceGridItemObject } from '@it2go/types';
import { ComponentStoreV2Factory } from '../../../../modules/shared/store/common/component-store-v2.factory';

@Injectable()
export class CascadeContractSelectInputStore extends ComponentStoreV2Factory {

    public services = computed(() => {
        const rules = this.globalGlobalStore.loggedUserStore.rules();

        return this.globalGlobalStore.organizationStore.services()
            .filter((it: ServiceGridItemObject) =>
                this.isAllowedForServiceInRules(rules, 'user.update', it.id) ||
                this.isAllowedForServiceInRules(rules, 'user.create', it.id))
            .map((it) => {
                return {
                    ...it,
                    contracts: Object.values(EmploymentContractEnum).map(ec => (
                        {
                            id: `${it.id}:${ec}`,
                            value: ec,
                            parentName: it.name,
                            parentId: it.id,
                            workplaces: it.workplaces,
                        }
                    )),
                };
            });
    });

    private isAllowedForServiceInRules(rules: Record<Operations | string, { serviceIds?: Set<number> }>, operation: Operations, serviceId: number): boolean {
        const serviceIds = rules[operation]?.serviceIds;
        return serviceIds?.has(serviceId) || serviceIds?.has(0) || false;
    }

}
